import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-framing',
  templateUrl: './framing.component.html',
  styleUrls: ['./framing.component.scss']
})
export class FramingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
